import formioController from "webforms/formio/formio.controller";
import AutoQuery from "servicestack/auto-query/auto-query";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import config from "emun.auth/auth.config";

export default class FormIoSubmissionController {
	constructor($scope) {
		const $ctrl = this;
		formioController($ctrl, $scope);
		var bus = ($ctrl.bus = new ServiceBus());
		$ctrl.formSubmitted = false;
		$ctrl.config = config;
		$ctrl.submission = {
			label: $ctrl.formioId,
			data: {},
		};
		$ctrl.getFormIO($ctrl.formioId).then((f) => {
			$ctrl.formio = f;
			$ctrl.submission.label = f.id; //f.label;
			$ctrl.prePopulateData();
			if ($ctrl.submissionId) {
				$ctrl.getFormSubmission($ctrl.submissionId).then((submission) => {
					$ctrl.submission = submission;
				});
			}
		});
		//$ctrl.prePopulateData = prePopulateData.bind($ctrl);
	}
	prePopulateData() {
		const $ctrl = this;
		$ctrl.bus
			.send("QuerySalesRepList.json?Active=1&OrderBy=Name")
			.then(function (res) {
				var component = $ctrl.getComponentByKey($ctrl.formio.fields, "salesRepLookup");
				if (component && component.length) {
					component[0].values = [];
					res.data.results.forEach(function (obj) {
						component[0].data.values.push({ value: obj.id, label: obj.name });
					});
				}
			});
		if ($ctrl.$session.isAuthenticated && $ctrl.$session.isRetailer()) {
			if ($ctrl.$session.retailerId && !$ctrl.retailer) {
				$ctrl.bus
					.send(`QueryRetailers.json?Id=${$ctrl.$session.retailerId}`)
					.then(function (res) {
						if (res.data.results) {
							$ctrl.retailer = res.data.results[0];
							$ctrl.submission.data.companyName = $ctrl.retailer.companyName;
							$ctrl.submission.data.customerId = $ctrl.retailer.id;
							$ctrl.submission.data.retailerId = $ctrl.retailer.id;
							$ctrl.submission.data.billingAddress =
								$ctrl.retailer.billingLocation.address;
							$ctrl.submission.data.billingAddress2 =
								$ctrl.retailer.billingLocation.address2;
							$ctrl.submission.data.billingCity =
								$ctrl.retailer.billingLocation.city;
							$ctrl.submission.data.billingState =
								$ctrl.retailer.billingLocation.state;
							$ctrl.submission.data.billingZip =
								$ctrl.retailer.billingLocation.zip;
							$ctrl.submission.data.phone = $ctrl.retailer.phone;
							$ctrl.submission.data.email = $ctrl.retailer.email;
						}
					});
			}
			$ctrl.bus
				.send(
					`QueryRetailerShippingLocations.json?RetailerId=${$ctrl.$session.retailerId}`
				)
				.then(function (res) {
					if (res.data.results.length) {
						$ctrl.shippingLocation = res.data.results[0];
						$ctrl.submission.data.shippingAddress =
							$ctrl.shippingLocation.address;
						$ctrl.submission.data.shippingAddress2 =
							$ctrl.shippingLocation.address2;
						$ctrl.submission.data.shippingCity = $ctrl.shippingLocation.city;
						$ctrl.submission.data.shippingState =
							$ctrl.shippingLocation.state;
						$ctrl.submission.data.shippingZip = $ctrl.shippingLocation.zip;
					}
				});
			$ctrl.bus
				.send(
					`QueryRetailerContacts.json?RetailerId=${$ctrl.$session.retailerId}&IsPrimary=true`
				)
				.then(function (res) {
					if (res.data.results.length) {
						$ctrl.contact = res.data.results[0];
						$ctrl.submission.data.contact = $ctrl.contact.name;
						$ctrl.submission.data.email = $ctrl.contact.email;
					}
				});
		}
	}
	formSubmission(e, submission) {
		const $ctrl = this;
		console.debug("formSubmission", { $ctrl, e, submission });
		$ctrl.submission = submission;
		var component = $ctrl.getComponentByKey($ctrl.formio.fields, "clearForm");
		if (component && component.length) {
			console.debug("clearing form");
			$ctrl.formSubmitted = false;
			$ctrl.submission = Object.assign({}, { label: $ctrl.formioId, data: {} });
		} 
		component = $ctrl.getComponentByKey($ctrl.formio.fields, "redirectSubmissionURL");
		if (component && component.length) {
			console.debug("redirecting form" + submission.data.redirectSubmissionURL);
			window.location.href = submission.data.redirectSubmissionURL;
		} 
		if ($ctrl.formio.formType == "Registration") {
			if ($ctrl.config.retailerRequestRedirectUrl && $ctrl.config.retailerRequestRedirectUrl != "") {
				window.location.href = $ctrl.config.retailerRequestRedirectUrl;
			}
		}
	}
	formChanged(e, submission) {
		const $ctrl = this;
		console.info("hi", submission.data);
		if (submission.data.zipcodeRepLookup && submission.data.zipcodeRepLookup.length === 5) {
			$ctrl.bus.send('QuerySalesRepZipcode.json?Zipcode=' + submission.data.zipcodeRepLookup).then(function (res) {
				if (res.data.total == 1) {
					$ctrl.submission.data.territoryRepId = res.data.results[0].id;
					$ctrl.submission.data.territoryRepName = res.data.results[0].name;
				}
			});
		}
		if (submission.data.MERGEVAR_zipCode && submission.data.MERGEVAR_zipCode.length === 5) {
		$ctrl.bus.send('QueryEmployees?ZipcodesContains=' + submission.data.MERGEVAR_zipCode).then(function(res) {
			$ctrl.MudPieTerritoryManager = res.data.results.filter(r => r.type == "Mud Pie Sales Division");
			$ctrl.GiftDivisionTerritoryManager = res.data.results.filter(r => r.type == "Gift Division");
			if ($ctrl.MudPieTerritoryManager.length) {
			submission.data.MudPieTerritoryManagerEmail = $ctrl.MudPieTerritoryManager[0].email;
			}
			if ($ctrl.GiftDivisionTerritoryManager.length) {
			submission.data.GiftDivisionTerritoryManagerEmail = $ctrl.GiftDivisionTerritoryManager[0].email;
			}
			var emails = [];
			if (submission.data.notify == "customerService") emails.push("webadmins@onecoast.com");
			if (submission.data.notify == "mudPieTerritoryManager") emails.push(submission.data.MudPieTerritoryManagerEmail);
			if (submission.data.notify == "giftDivisionTerritoryManager") emails.push(submission.data.GiftDivisionTerritoryManagerEmail);
			// if (submission.data.notify.customerService) emails.push("webadmins@onecoast.com");
			// if (submission.data.notify.mudPieTerritoryManager) emails.push(submission.data.MudPieTerritoryManagerEmail);
			// if (submission.data.notify.giftDivisionTerritoryManager) emails.push(submission.data.GiftDivisionTerritoryManagerEmail);
			submission.data.email = emails.join(";");
		});
		};
	}
}



